export default "__VITE_ASSET__vrx8NeVV__"